import { CircularProgress, Grid, MenuItem } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactSVG } from "react-svg";
import api from "../../../../../../api/api";
import imgs from "../../../../../../assets/images/imgs";
import StudentTeacherprofileChatbot from "../../../../../../components/StudentTeacherprofileChatbot";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import StudentDashboardChatbot from "../chatbot/StudentChatbot";
import StudentSuggesionCourseData from "../course/StudentSuggesionCourseData";
import StudentSuggesionTeacherCard from "../course/StudentSuggesionTeacherCard";
import StudentCourseCard from "../course/StudentCourseCard";
import { useNavigate } from "react-router";
import { updateGlobalState } from "../../../../../../state/global/slice";
import Filter from "../../Filter";
import "../../Filter.css";
import {
  FilterSVG,
  sort,
  arrow_outward,
} from "../../../../../../assets/images/images";
import StyledMenu from "../../../../../../components/StyleMenu";
import { toast } from "react-toastify";
import { startAiCourseStatusPolling } from "../teacher/aiCourseStatusPolling";

function ProschoolStudentHome({
  removeTeacherActiveChat,
  profileFirstName,
  showTooltip,
  setShowTooltip,
  teacherChat,
  setTeacherChat,
  onClickTeacher,
  activeTeacher,
  handleTeacherClick,
  chatbotTeacherStatus,
  setTeacherchatbotStatus,
  getTeacherActiveChat,
  setTeacherActiveChat,
  setActiveTab,
  newStudFirstRender = false,
  loader=false
}) {
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();
  const [TempglobalState, setTempglobalState] = useState("");

  const get_teacher_list = globalState?.get_teacher_list?.data ?? [];

  const [showteacherProfile, setShowteacherProfile] = useState(false); // State to control visibility
  const modalRef = useRef();
  const modalContentRef = useRef(); // Reference to the modal content
  const isMarketplace = globalState.enabled_modules?.includes("marketplace");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = useState(false);
  const [filtertype, setfiltertype] = useState("");
  const [filter, setFilter] = useState({
    browse_by: [],
    subjects: [],
    courses: [],
    pricing: [],
    course_status: [],
    ratings: [],
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const openModal = () => {
    setShowteacherProfile(true);
  };

  const toggleteacherProfile = () => {
    setShowteacherProfile(false);
  };

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target)
      ) {
        toggleteacherProfile();
      }
    };

    if (showteacherProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showteacherProfile]);

  const [search, setSearch] = useState("");
  const serachhandleInputChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    setCurrentPage(1);
  };

  const changeSubjectFillter = (value) => {
    const selectedSubject =
      typeof value === "object" ? value?.target?.value : value;
    setSelectedSubject(selectedSubject);
    setTempglobalState(selectedSubject);
    setCurrentPage(1);
  };

  const statusPriority = (status) => {
    switch (status) {
      case "Pending":
        return 1;
      case "Active":
        return 2;
      default:
        return 3;
    }
  };

  const { token } = useAuth();
  const [courses, setCourses] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [result , setresult] = useState(0);
  const itemsPerPage = 8;
  const [loading, setLoading] = useState(false);

  const fetchCourses = async (page, retry = false) => {
    try {
      setLoading(true);
      const response = await api.post(
        `courses/student/my-courses-dashboard/v2/?page=${page}`,
        {
          search: search,
          sort: TempglobalState,
          browse_by: filter.browse_by,
          subject: filter.subjects,
          courses: filter.courses,
          pricing: filter.pricing,
          course_status: filter.course_status,
          ratings: filter.ratings,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      );

      const data = response.data;

      setCourses(data.data);

      const isMyCoursesChecked = filter.courses.includes("my_courses");
      const suggestedCount = isMyCoursesChecked
        ? data.count
        : data.suggested_count ?? 0;

      setTotalPages(Math.ceil(suggestedCount / itemsPerPage));
      setNextUrl(data.next);
      setPrevUrl(data.previous);

      // AUTO REFETCH FOR NEWLY INVITED STUDENTS
      const hasNoCourses =
        (!data?.data?.my_courses || data?.data?.my_courses?.length === 0) &&
        (!data?.data?.suggested_course ||
          data?.data?.suggested_course?.length === 0);

      if (hasNoCourses && !retry) {
        setTimeout(() => {
          fetchCourses(page, true);
        }, 2000);
      }
    } catch (error) {
      console.error("Fetching error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  // Reset to page 1 when filters/search/sort change
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch, TempglobalState, filter]);

  // FIX: Single source of truth for course fetching.
  // Removed the duplicate fetchCourses call from the [] useEffect below,
  // and removed the globalState.student_courses sync effect — both caused
  // race conditions that overwrote correctly fetched data with stale/empty values.
  useEffect(() => {
    fetchCourses(currentPage);
  }, [token, currentPage, debouncedSearch, TempglobalState, filter]);

  // FIX: Only fetch teacher list here — fetchCourses is handled above.
  // Previously this also called fetchCourses(currentPage), causing two
  // concurrent requests on mount that raced each other.
  useEffect(() => {
    const controller = new AbortController();

    const fetchTeacherList = async () => {
      try {
        const { data } = await api.get("/auth/get-teacher-list/", {
          signal: controller.signal,
          headers: { Authorization: `Token ${token}` },
        });
        if (data.status === 200) updateState("get_teacher_list", data ?? {});
      } catch (error) {
        if (error.name === "CanceledError") return;
        console.error("Failed to fetch teacher list:", error);
      }
    };

    fetchTeacherList();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

    useEffect(() => {
      const studentCourses = globalState?.student_courses;
      const hasMyCourses = Array.isArray(studentCourses?.my_courses) && studentCourses.my_courses.length > 0;
      const hasSuggestedCourses = Array.isArray(studentCourses?.suggested_course) && studentCourses.suggested_course.length > 0;
      if(studentCourses && (hasMyCourses || hasSuggestedCourses)){
      setCourses(globalState?.student_courses || []);
      }
    }, [globalState?.student_courses]);

  // ── AI course generation polling ───────────────────────────────────────────
  // Snapshot the suggested courses still being generated and hand them to the
  // module-level poller. The interval itself lives outside React, so unmounting
  // this component (tab switch, navigation) does not stop it, and the session is
  // persisted so a page refresh resumes it. Only { action: "done", course_id: null }
  // stops it.
  const aiCoursesCapturedRef = useRef(false);

  useEffect(() => {
    if (aiCoursesCapturedRef.current || !token) return;

    const suggestedCourses = courses?.suggested_course;
    // Wait for the first real list — an empty/absent one is just "not fetched yet".
    if (!Array.isArray(suggestedCourses) || suggestedCourses.length === 0) return;

    aiCoursesCapturedRef.current = true;

    const pendingCourses = suggestedCourses.filter(
      (course) =>
        course?.ai_course_generated &&
        course?.student_top_course &&
        course?.is_all_generated === false &&
        course?.course_id !== undefined &&
        course?.course_id !== null &&
        course?.course_id !== "",
    );

    if (pendingCourses.length === 0) return; // nothing generating — don't start

    // course_id -> teacher, needed for the create-lessons payload later.
    const teacherByCourseId = {};
    pendingCourses.forEach((course) => {
      teacherByCourseId[String(course.course_id)] = course?.teacher;
    });

    startAiCourseStatusPolling({
      token,
      courseIds: [...new Set(pendingCourses.map((c) => String(c.course_id)))],
      teacherByCourseId,
    });
  }, [courses, token]);

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const activeCourses =
    globalState?.student_details?.data?.my_courses?.active_courses;

  const assignmentsCount =
    globalState?.student_details?.data?.my_courses?.pending_assignments;

  let coursesSortedArray = [];
  if (isMarketplace) {
    if (
      Array.isArray(courses?.suggested_course) &&
      courses.suggested_course.length
    ) {
      coursesSortedArray = [...courses.suggested_course].sort((a, b) => {
        return statusPriority(a.status) - statusPriority(b.status);
      });
    }
  } else if (Array.isArray(courses?.my_courses)) {
    coursesSortedArray = [...courses.my_courses].sort((a, b) => {
      return statusPriority(a.status) - statusPriority(b.status);
    });
  } else if (Array.isArray(courses) && courses.length) {
    coursesSortedArray = [...courses].sort((a, b) => {
      return statusPriority(a.status) - statusPriority(b.status);
    });
  }

  let myCourseArray = [];
  if (Array.isArray(courses?.my_courses) && courses.my_courses.length) {
    myCourseArray = [...courses.my_courses];
  }

  const serialOrder = ["1", "2", "3", "4", "5"];

  function getCourseToShowSequentially(allCourses, examType) {
    if (!Array.isArray(allCourses)) return null;

    const filtered = allCourses.filter(
      (c) => c.type === 2 && c.competitive_exam === examType,
    );

    filtered.sort(
      (a, b) =>
        serialOrder.indexOf(a.comp_course_serial_no) -
        serialOrder.indexOf(b.comp_course_serial_no),
    );

    for (const course of filtered) {
      if ((course.status ?? "").toLowerCase() !== "completed") {
        return course;
      }
    }

    return null;
  }

  const courseType2SATToShow = getCourseToShowSequentially(
    coursesSortedArray,
    "SAT",
  );
  const courseType2ACTToShow = getCourseToShowSequentially(
    coursesSortedArray,
    "ACT",
  );

  const otherCourses = coursesSortedArray.filter((c) => c.type !== 2);

  return (
    <>
      <div className="studentDashboar-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="studentDashboar-wrapper">
                <h2>Hello {profileFirstName}!</h2>
                <div className="studentDashboar-actives-container">
                  <div
                    className="studentDashboar-actives-folder"
                    onClick={openModal}
                  >
                    <div className="studentDashboar-actives-image">
                      <img src={imgs.png.Teacher_profile} alt="" />
                    </div>
                    <div className="studentDashboar-actives-course-count">
                      <h2>
                        {
                          get_teacher_list.filter(
                            (teacher) =>
                              teacher?.first_course?.course_id !== null,
                          )?.length
                        }
                      </h2>
                      <p>My Teacher</p>
                    </div>
                  </div>
                  {showTooltip && (
                    <div
                      className={`teacher_tooltip ${showTooltip ? "show" : ""}`}
                    >
                      <p>
                        Click on "My Teacher" tab to chat with the teacher's AI.
                      </p>
                      <button
                        onClick={() => setShowTooltip(false)}
                        className="tooltip_btn"
                      >
                        Got it
                      </button>
                      <img
                        src={imgs.png.tooltip_trangle}
                        alt="tooltip trangle"
                        className="tooltip_trangle"
                      />
                    </div>
                  )}
                  <div
                    className="studentDashboar-actives-folder py-3"
                    onClick={() => {
                      navigate("/dashboard/my-courses/active-courses", {
                        state: { activeTab: "active-courses" },
                      });
                      setActiveTab("My Courses");
                    }}
                  >
                    <div className="studentDashboar-actives-image">
                      <img src={imgs.png.Active_course} alt="" />
                    </div>
                    <div className="studentDashboar-actives-course-count">
                      <h2>{activeCourses}</h2>
                      <p>
                        {activeCourses > 1 ? "Active Courses" : "Active Course"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="studentDashboar-Suggested-Courses-wrapper">
                  <div className="studentDashboar-Suggested-Courses-short-by-filter-container">
                    <h3
                      className="studentDashboar-Suggested-Courses-short-by-filter-title"
                      style={{ width: "170px" }}
                    >
                      My Courses
                    </h3>
                    <div className="studentDashboar-Suggested-Courses-short-by-filter-serach-inner-inputBB">
                      <div className="studentDashboar-search-filter">
                        <input
                          type="text"
                          name="search"
                          value={search}
                          onChange={serachhandleInputChange}
                          placeholder={
                            isMarketplace
                              ? "Search courses, subjects, teachers"
                              : "Search courses"
                          }
                        />
                        <div className="serach-input-icon">
                          <ReactSVG src={imgs.svg.search} alt="" />
                        </div>
                      </div>
                      {isMarketplace && (
                        <div className="studentDashboar-Suggested-Courses-short-by-filter-section">
                          <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOpen(true);
                                setfiltertype("Enrolled");
                              }}
                            >
                              <img src={FilterSVG} alt="filter" /> Filter
                            </span>
                            <div
                              className={`drawer-overlay ${open ? "show" : ""}`}
                              onClick={() => setOpen(false)}
                            />
                            <div className={`drawer ${open ? "open" : ""}`}>
                              <div className="drawer-header">
                                <h3>Filter</h3>
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
  <h5 style={{marginRight:"25px"}}>Result({result?.result_count || 0})</h5>
                                  <button
                                  className="close-btn"
                                  onClick={() => setOpen(false)}
                                >
                                  &#10005;
                                </button>
</div>
                              </div>
                              <Filter 
                                setOpen={setOpen}
                                setresult={setresult}
                                filtertype={filtertype}
                                filter={filter}
                                setFilter={setFilter}
                              />
                            </div>
                          </div>
                          <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={handleClick}
                            >
                              <img src={sort} alt="sort" /> Sort
                            </span>
                            <StyledMenu
                              anchorEl={anchorEl}
                              id="account-menu"
                              open={open1}
                              onClose={handleClose}
                              onClick={handleClose}
                              slotProps={{
                                paper: {
                                  minWidth: 180,
                                  elevation: 0,
                                  sx: { overflow: "visible", mt: 1.5 },
                                },
                              }}
                              transformOrigin={{
                                horizontal: "right",
                                vertical: "top",
                              }}
                              anchorOrigin={{
                                horizontal: "right",
                                vertical: "bottom",
                              }}
                            >
                              <MenuItem
                                selected={selectedSubject === ""}
                                onClick={() => changeSubjectFillter("")}
                              >
                                Most Relevant
                              </MenuItem>
                              <MenuItem
                                selected={
                                  selectedSubject === "price_low_to_high"
                                }
                                onClick={() =>
                                  changeSubjectFillter("price_low_to_high")
                                }
                              >
                                Price: Low to High
                              </MenuItem>
                              <MenuItem
                                selected={
                                  selectedSubject === "price_high_to_low"
                                }
                                onClick={() =>
                                  changeSubjectFillter("price_high_to_low")
                                }
                              >
                                Price: High to Low
                              </MenuItem>
                              <MenuItem
                                selected={selectedSubject === "course_rating"}
                                onClick={() =>
                                  changeSubjectFillter("course_rating")
                                }
                              >
                                Top Rated Courses
                              </MenuItem>
                               <MenuItem
                                selected={selectedSubject === "top_rated_teachers"}
                                onClick={() =>
                                  changeSubjectFillter("top_rated_teachers")
                                }
                              >
                                Top Rated Teachers
                              </MenuItem>
                            </StyledMenu>
                          </div>
                        </div>
                      )}
                      {!isMarketplace && (
                        <div className="studentDashboar-Suggested-Courses-short-by-filter-section">
                          <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
                            <span>Filter By :</span>
                            <select
                              className="studentDashboar-course-filter"
                              onChange={changeSubjectFillter}
                            >
                              <option value="">Suggested</option>
                              <option value="English">English</option>
                              <option value="Physics">Physics</option>
                              <option value="Chemistry">Chemistry</option>
                              <option value="Math">Math</option>
                              <option value="Science">Science</option>
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                    {(loading || loader) && (
                      <Grid
                        height={"50vh"}
                        xs={12}
                        container
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={80} />
                      </Grid>
                    )}

                  {/* MY COURSES (marketplace: StudentCourseCard) */}
                  {isMarketplace && (
                    <div className="studentDashboar-Suggested-Courses-container">
                      {!loading && myCourseArray?.length > 0
                        ? myCourseArray.map((course, index) => (
                            <StudentCourseCard key={index} course={course} />
                          ))
                        : null}
                    </div>
                  )}

                  {/* SUGGESTED / ALL COURSES & TEACHERS */}
                  <div className="studentDashboar-Suggested-Courses-container">
                    {!loading && coursesSortedArray?.length > 0
                      ? coursesSortedArray.map((course, index) => {
                          // Render teacher card if card_type is "teacher"
                          if (course.card_type === "teacher") {
                            return (
                              <StudentSuggesionTeacherCard
                                key={`teacher-${course.teacher_id}-${index}`}
                                teacher={course}
                              />
                            );
                          }
                          // Render course card (original logic unchanged)
                          return (
                          <StudentSuggesionCourseData
                            key={index}
                            newStudFirstRender = {newStudFirstRender}
                            course={course}
                            from="/dashboard/home"
                          />
                        );
                        })
                      : null}
                  </div>

                  {!loading &&
                    (coursesSortedArray?.length === 0 && myCourseArray?.length === 0) && (
                      <div className="no-courses-available-container">
                        <div>No Courses Found</div>
                      </div>
                    )}
                </div>
                <br />
                <Grid xs={12} container justifyContent={"center"}>
                  {isMarketplace &&
                  !(
                    !loading &&
                    (coursesSortedArray?.length || myCourseArray?.length) === 0
                  ) ? (
                    <div className="View-all-studenthome">
                      {/* FIX: Removed duplicate hideNextButton prop */}
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={nextUrl === null}
                        hidePrevButton={prevUrl === null || currentPage === 1}
                      />
                    </div>
                  ) : (
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      hideNextButton={nextUrl === null}
                      hidePrevButton={prevUrl === null || currentPage === 1}
                    />
                  )}
                </Grid>

                <div className="StudentChatbot-section">
                  {getTeacherActiveChat.map((teacher, index) => (
                    <div key={index}>
                      {chatbotTeacherStatus && (
                        <StudentDashboardChatbot
                          key={index}
                          removeTeacherActiveChat={() =>
                            removeTeacherActiveChat(teacher)
                          }
                          right={index * 30}
                          ai_name={`${teacher.name}`}
                          teacher_id={teacher?.user}
                          courseId={
                            teacher?.first_course
                              ? (teacher?.first_course?.course_id ?? "")
                              : ""
                          }
                          isMinimize={teacher.isMinimized}
                          chatbotStatus={chatbotTeacherStatus}
                          lesson_name={
                            teacher?.first_lesson
                              ? (teacher?.first_lesson?.lesson_name ?? "")
                              : ""
                          }
                          ai_tone={teacher?.ai_tone}
                          ai_avatar={teacher?.ai_avatar}
                          ai_welcome_msg={teacher?.ai_welcome_msg}
                        />
                      )}
                    </div>
                  ))}
                </div>

                {showteacherProfile && (
                  <div
                    ref={modalRef}
                    className="studentDashboar-teacher-popup-section"
                  >
                    <div
                      ref={modalContentRef}
                      className="studentDashboar-teacher-popup-wrapper"
                      data-aos="zoom-in"
                    >
                      <h2 className="studentDashboar-teacher-title">
                        My Teachers
                      </h2>
                      <div
                        className="studentDashboar-teacher-popup-cross-btn"
                        onClick={toggleteacherProfile}
                      >
                        <i className="fa-solid fa-x"></i>
                      </div>
                      <div className="studentDashboar-teacher-popup-main-container">
                        <div className="studentDashboar-teacher-popup-container">
                          {get_teacher_list?.filter(
                            (teacher) =>
                              teacher?.first_course?.course_id !== null,
                          )?.length > 0 ? (
                            get_teacher_list
                              ?.filter(
                                (teacher) =>
                                  teacher?.first_course?.course_id !== null,
                              )
                              ?.map((teacher, index) => (
                                <StudentTeacherprofileChatbot
                                  key={index}
                                  closeTeacherProfile={toggleteacherProfile}
                                  onClickTeacher={() => onClickTeacher(teacher)}
                                  studentDashboar_teacher_image={
                                    teacher.ai_avatar ??
                                    imgs.png.tearcher_profile_image
                                  }
                                  teacherName={teacher.name}
                                  teacherId={teacher?.teacher_id}
                                  teacherTitleValue={teacher?.title}
                                />
                              ))
                          ) : (
                            <p>Please enroll in one of the course.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProschoolStudentHome;